import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';

/**
 * Generated class for the ComponetsEyesInfoComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'eyes-info',
  templateUrl: 'eyes-info.html'
})
export class EyesInfoComponent {

  info: any;

  constructor(public navParams: NavParams) {
    console.log('Hello EyesInfoComponent Component');
    this.info = this.navParams.get('info');
  }

}



// WEBPACK FOOTER //
// ./src/components/eyes-info/eyes-info.ts